const config = {
  Quote_API_KEY: "4834081dfbmsh97786876b293defp115530jsn1ac149a8bd0d",
};
export default config;
